import { render, staticRenderFns } from "./addDocumentDialog.vue?vue&type=template&id=61f5573a&"
import script from "./addDocumentDialog.vue?vue&type=script&lang=js&"
export * from "./addDocumentDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports